import React, { useEffect, useState } from 'react';
import { Container, Table, Tab, Tabs, Alert, Button, Modal,Pagination } from 'react-bootstrap';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../FireBase';

const FeedBack = () => {
  const [contactMessages, setContactMessages] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('contact-messages');
  const [showModal, setShowModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage1, setCurrentPage1] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        // Fetch feedback messages
        const feedbackRef = collection(db, 'FeedBack');
        const feedbackSnapshot = await getDocs(feedbackRef);
        const feedbackData = feedbackSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setFeedbacks(feedbackData);

        // Fetch contact messages
        const contactRef = collection(db, 'contact-form');
        const contactSnapshot = await getDocs(contactRef);
        const contactData = contactSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setContactMessages(contactData);

      } catch (err) {
        setError('Failed to fetch messages');
        console.error(err);
      }
    };

    fetchMessages();
  }, []);

  // Function to open modal with message details
  const handleOpenModal = (message) => {
    setSelectedMessage(message);
    setShowModal(true);
  };

  // Function to delete message
  const handleDeleteMessage = async (messageId, collectionName) => {
    if (window.confirm('Are you sure you want to delete this message?')) {
      try {
        await deleteDoc(doc(db, collectionName, messageId));
        
        if (collectionName === 'contact-form') {
          setContactMessages(prevMessages => prevMessages.filter(msg => msg.id !== messageId));
        } else if (collectionName === 'FeedBack') {
          setFeedbacks(prevFeedbacks => prevFeedbacks.filter(msg => msg.id !== messageId));
        }
      } catch (error) {
        console.error('Error deleting message:', error);
        setError('Failed to delete the message.');
      }
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = contactMessages.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const indexOfLastItem1 = currentPage1 * itemsPerPage;
  const indexOfFirstItem1 = indexOfLastItem1 - itemsPerPage;
  const currentItems1 = feedbacks.slice(indexOfFirstItem1, indexOfLastItem1);

  const paginate1= (pageNumber1) => setCurrentPage1(pageNumber1);
  return (
    <Container fluid className="inventory-page">
      <h1>Messages</h1>
      {error && <Alert variant="danger">{error}</Alert>}

      <Tabs id="messages-tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
        {/* Contact Messages Tab */}
        <Tab eventKey="contact-messages" title="Contact Messages">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Subject</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map(message => (
                  <tr key={message.id}>
                    <td>{message.name}</td>
                    <td>{message.email}</td>
                    <td>{message.phone}</td>
                    <td>{message.subject}</td>
                    <td>
                      <Button className="btn" variant="outline-primary" onClick={() => handleOpenModal(message)}>
                        Read
                      </Button>
                    </td>
                    <td>
                      <Button className="btn" variant="outline-danger" onClick={() => handleDeleteMessage(message.id, 'contact-form')}>
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No messages found.</td>
                </tr>
              )}
            </tbody>
          </Table>
            <Pagination>
              {Array.from({ length: Math.ceil(contactMessages.length / itemsPerPage) }, (_, index) => (
                  <Pagination.Item
                      key={index + 1}
                      active={index + 1 === currentPage}
                      onClick={() => paginate (index + 1)}                        
                  >
                      {index + 1}
                  </Pagination.Item>
              ))}
            </Pagination>
        </Tab>

        {/* Feedback Messages Tab */}
        <Tab eventKey="feedback-messages" title="Feedbacks">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Username</th>
                <th>Date</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems1.length > 0 ? (
                currentItems1.map(feedback => (
                  <tr key={feedback.id}>
                    <td>{feedback.username}</td>
                    <td>{feedback.date}</td>
                    <td>
                      <Button className="btn" variant="outline-primary" onClick={() => handleOpenModal(feedback)}>
                        Read
                      </Button>
                    </td>
                    <td>
                      <Button className="btn" variant="outline-danger" onClick={() => handleDeleteMessage(feedback.id, 'FeedBack')}>
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No feedback found.</td>
                </tr>
              )}
            </tbody>
          </Table>
            <Pagination>
                {Array.from({ length: Math.ceil(feedbacks.length / itemsPerPage) }, (_, index) => (
                    <Pagination.Item
                        key={index + 1}
                        active={index + 1 === currentPage1}
                        onClick={() => paginate1 (index + 1)}                        
                    >
                        {index + 1}
                    </Pagination.Item>
                ))}
            </Pagination>
        </Tab>
      </Tabs>

      {/* Modal to show message details */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Message Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMessage && (
            <>
              <p><strong>Name:</strong> {selectedMessage.name || 'N/A'}</p>
              <p><strong>Email:</strong> {selectedMessage.email || 'N/A'}</p>
              <p><strong>Phone:</strong> {selectedMessage.phone || 'N/A'}</p>
              <p><strong>Subject:</strong> {selectedMessage.subject || 'N/A'}</p>
              <p><strong>Message:</strong> {selectedMessage.message || 'N/A'}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default FeedBack;
